/**
Copyright (c) 2023, 2024, 2025 Amica Corp.
All rights reserved.

This source code, resulting binary forms, and associated documentation
(the "Software") may only be used, modified, or distributed, with or
without modification, under the terms of a written license agreement
with Amica Corp. (the "License"). All rights to manufacture, use,
redistribute, or sell anything described herein, in whole or in part,
are granted only as explicitly permitted by such License. The receipt
or possession of the Software does not convey any of these rights.

This Software is provided "AS IS," WITHOUT WARRANTY OF ANY KIND, express
or implied, including but not limited to the implied warranties of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.

For additional terms, see https://amica.cloud/software-copyright/
 */

import { useSelector, useDispatch } from 'react-redux';
import { selectLoader } from 'modules/sign-in/selectors';
import { useEffect } from 'react';
import { Loader } from 'modules/common/components';
import { notificationActions } from 'modules/common/notifications/slice';
import useIsAuthenticated from 'modules/common/auth/hooks/use-is-authenticated';
import { useNavigate } from 'react-router-dom';
import ROUTES from 'modules/common/constants/route';
import { authActions } from 'modules/common/auth/slice';
import { selectTokens } from 'modules/common/auth/selectors';
import { isEmpty } from 'modules/common/helpers/object';
import openAuthWindow from 'modules/common/utils/auth';
import calculateActiveUserTime from 'modules/common/utils/active-user-time';
import { ENVIRONMENT } from 'config';

/**
 * Parent sign in component define here. All the sub component load into here
 * @returns
 */
const SignInView = () => {
  // get authenticated state
  const { isAuthenticated } = useIsAuthenticated();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  //
  const loading = useSelector(selectLoader);
  const tokens = useSelector(selectTokens);
  //
  const isPtg = window.location.origin === ENVIRONMENT.APP_URL;
  // reset notifications
  useEffect(() => dispatch(notificationActions.resetNotification()), [isAuthenticated]);
  //
  useEffect(() => {
    if (!isAuthenticated()) {
      if (tokens && !isEmpty(tokens) && tokens?.refreshToken !== '') {
        // calculate the user activeness on sign out
        calculateActiveUserTime();
        dispatch(authActions.signOut());
        openAuthWindow(isPtg);
      } else {
        openAuthWindow(isPtg);
      }
    } else {
      navigate(ROUTES.DASHBOARD);
    }
  }, [tokens]);

  return <Loader loading={loading} />;
};
//
export default SignInView;
